import { render } from "./input.vue?vue&type=template&id=75c877d6"
import script from "./input.vue?vue&type=script&lang=js"
export * from "./input.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vendor/vvg/forum/resources/vue/components/form/input.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "75c877d6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('75c877d6', __exports__)) {
    console.log('reload')
    api.reload('75c877d6', __exports__)
  }
  
  module.hot.accept("./input.vue?vue&type=template&id=75c877d6", () => {
    console.log('re-render')
    api.rerender('75c877d6', render)
  })

}


export default __exports__